import { IsNumber, IsOptional, IsString } from "class-validator";
import { Expose } from "class-transformer";

export default class OrderItemPurchaseNetPrice {
  @IsOptional()
  @IsString()
  @Expose()
  purchaseNetValueCurrency!: string;
  @IsOptional()
  @IsString()
  @Expose()
  purchaseNetValueExchangeDate!: string;
  @IsNumber()
  @Expose()
  purchaseNetValueExchangeRate!: number;
  @IsNumber()
  @Expose()
  purchaseNetValue!: number;
  @IsNumber()
  @Expose()
  purchaseNetValueInCurrency!: number;
}
